<app-base-action-modal
  modalTitle="Unlock Defined Contribution Assets"
  i18n-modalTitle
  primaryLabel="Save"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (primaryClicked)="submit()"
  (secondaryClicked)="cancel()"
  (closeClicked)="cancel()">
  <ng-container *ngIf="summary$ | async as summary">
    <div class="d-flex flex-column" [style.gap.rem]="2">
      <div i18n class="paragraph-lg">
        This action unlocks the locked-in funds for the below jurisdiction. Ensure that the unlocking process adheres to
        the relevant jurisdictional regulations.
      </div>

      <div class="d-flex flex-column gap-4">
        <app-final-location-line class="label-md" [finalLocationId]="summary.finalLocationId" />

        <div class="jurisdiction-card justify-content-between align-items-center">
          <div class="d-flex flex-column gap-2">
            <div class="label-md">
              {{ summary.rulesJurisdictionId | governingJurisdictionName }} <span i18n>Locked-In Funds</span>
            </div>
            <div class="paragraph-lg grey">{{ summary.lockedBalance | currency }}</div>
          </div>
          <div *ngIf="summary.isMaxJurisdiction" class="paragraph-lg grey text-end max-unlock" i18n>
            The maximum unlock is 50.00% ({{ summary.maxDollarAmount | currency }})
          </div>
        </div>
      </div>

      <div *ngIf="summary.hasExistingUnlock">
        <div class="d-flex align-items-center" [style.gap.rem]="0.75">
          <app-checkbox-input [formControl]="form.controls.revertToOriginal" controlId="revertToOriginal" />
          <app-form-option-label labelFor="revertToOriginal" i18n>
            Revert to original Locked-In Funds
          </app-form-option-label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="showUnlockSection$ | async">
      <hr class="divider" />

      <div *ngIf="!summary.isPooled" class="mb-4">
        <app-button-toggle
          [toggleOptions]="toggleOptions"
          [selectedValue]="allocationMode$ | async"
          (valueChanged)="toggleMode($event)" />
      </div>

      <div class="d-flex flex-column gap-3">
        <div *ngIf="(allocationMode$ | async) === 'percent'" class="d-flex flex-column gap-1" [style.width.%]="50">
          <label i18n class="form-input-label" for="lockedPercentageToUnlock">Amount to Unlock</label>
          <app-percentage-input
            [formControl]="form.controls.percentage"
            controlId="lockedPercentageToUnlock"
            placeholder="0.00"
            [error]="formSubmitted && form.controls.percentage.invalid"
            (focusout)="onAmountBlur()" />
          <app-form-error
            *ngIf="formSubmitted && form.controls.percentage.invalid"
            [errors]="form.controls.percentage.errors"
            [customErrorMessages]="customPercentageErrorMessages" />
        </div>

        <div *ngIf="(allocationMode$ | async) === 'dollar'" class="d-flex flex-column gap-1" [style.width.%]="50">
          <label i18n class="form-input-label" for="lockedAmountToUnlock">Amount to Unlock</label>
          <app-currency-input
            [formControl]="form.controls.amount"
            controlId="lockedAmountToUnlock"
            placeholder="0.00"
            [error]="formSubmitted && form.controls.amount.invalid"
            (focusout)="onAmountBlur()" />
          <app-form-error
            *ngIf="formSubmitted && form.controls.amount.invalid"
            [errors]="form.controls.amount.errors"
            [customErrorMessages]="customAmountErrorMessages" />
        </div>

        <div *ngIf="summary.isMaxJurisdiction" class="d-flex align-items-center" [style.gap.rem]="0.75">
          <app-checkbox-input [formControl]="form.controls.useMax" controlId="useMax" />
          <app-form-option-label labelFor="useMax" i18n>Use Max</app-form-option-label>
        </div>
      </div>

      <div *ngIf="warningAlert$ | async as warningAlert" [style.margin-top.rem]="2">
        <app-system-banner-alert [alert]="warningAlert" />
      </div>
    </ng-container>
  </ng-container>
</app-base-action-modal>
